var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wb-bar",style:(_vm.wbBarSize)},[_c('span'),_c('span'),_c('span'),_c('span'),_c('span'),_c('span')])
}
var staticRenderFns = []

export { render, staticRenderFns }